import React, { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Await, useLoaderData } from "react-router-dom";

export default function HybridHitlistRegionPicker({ formData, setFormData, name, filterFunction = () => true, disabled, loadOnChange }) {
    const { regions } = useLoaderData();

    async function handleChange(value) {
        let formDataCopy = { ...formData, region: value };
        if (loadOnChange && value.length) {
            const savedFormData = await loadOnChange(value[0].digital_id ?? value[0].mix_id);
            if (savedFormData) {
                formDataCopy = { ...formData, ...savedFormData, region: value };
            }
        }
        setFormData(formDataCopy);
    }

    return (
        <Suspense fallback={<Fallback name={name} />}>
            <Await resolve={regions}>
                {resolvedRegions => (
                    <Form.Group as={Col} className="col-12 col-xl-3 min-w-station">
                        <Form.Label>Region</Form.Label>
                        <Typeahead
                            id={`${name}-region-selection`}
                            options={resolvedRegions.data.filter(filterFunction)}
                            labelKey={"name"}
                            highlightOnlyResult
                            placeholder="Select region..."
                            clearButton={true}
                            onChange={handleChange}
                            selected={formData.region}
                            disabled={disabled || false}
                        />
                    </Form.Group>
                )}
            </Await>
        </Suspense>
    );
}

function Fallback({ name }) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-3 min-w-station">
            <Form.Label>Region</Form.Label>
            <Typeahead id={`${name}-region-selection-fallback`} options={[]} placeholder="Loading regions..." disabled />
        </Form.Group>
    );
}
